// Push notifications
import { API_BASE } from './state.js';
import { showToast } from './utils.js';

let vapidKey = null;

export async function initPushNotifications() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.log('Push notifications not supported');
    return;
  }
  
  try {
    // Get VAPID key
    const res = await fetch(`${API_BASE}/push/vapid-key`);
    const data = await res.json();
    vapidKey = data.key;
    
    if (!vapidKey) {
      console.log('Push notifications not configured on server');
      return;
    }
    
    // Register service worker
    const registration = await navigator.serviceWorker.register('/sw.js');
    console.log('Service worker registered');
    
  } catch (error) {
    console.error('Push init error:', error);
  }
}

export async function subscribeToPush() {
  if (!vapidKey) {
    showToast('Push notifications not available', 'error');
    return false;
  }
  
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      showToast('Notification permission denied');
      return false;
    }
    
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey)
    });
    
    await fetch(`${API_BASE}/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ subscription })
    });
    
    showToast('Breaking news alerts enabled!');
    return true;
  } catch (error) {
    console.error('Push subscribe error:', error);
    showToast('Failed to enable notifications', 'error');
    return false;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
